import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'image'
})
export class ImagePipe implements PipeTransform {
  private url = environment.url;
  private defaultImg = '/assets/img/logo/logo-admin.png';

  transform(media: any[] | string): string {
    if(!media) return this.defaultImg;
    const extractedImg = typeof media === 'object' ? media[0].img : media;
    const image = `${this.url}/file/${extractedImg}`;
    return image;
  }

}
